import { select, takeEvery, put, takeLatest, call } from 'redux-saga/effects';
import {CLOSE_ASS_REQUEST, START_ASS_REQUEST} from '../constants/assistanceRequest.constants';
import { AssistanceRequestAPI } from '../../utils/API/AssistanceRequestAPI';
import { selectOptions } from '../../containers/PresentationPage/selectors';
import { setActiveAssistanceRequestId} from "../actions/assistanceRequest.actions";
import { closeAlarms } from '../actions/alarm.actions';
import { v4AlarmToClose } from '../../containers/AssistanceRequestPage/functions';
import { consoleWarn } from '../../utils/log';

const api = new AssistanceRequestAPI();

function *startAssistanceRequest({config}) {
  let page = yield select(selectOptions());
  yield api.start(config, page ? page.id : null);
}

function *closeAssistanceRequest({assistanceRequest, notes}) {
  yield put(setActiveAssistanceRequestId(null));
  if (assistanceRequest?.get?.('v4')) {
    yield call(closeV4AssistanceRequest, assistanceRequest, notes);
    return;
  }
  yield api.close(assistanceRequest.id, notes);
}

// A V4 request is a V4 alarm, so the V4 alarm close takes it. Guarded: an escaped error kills appSaga.
function *closeV4AssistanceRequest(assistanceRequest, notes) {
  try {
    const alarm = v4AlarmToClose(assistanceRequest, notes);
    if (alarm) yield put(closeAlarms([alarm]));
    else consoleWarn('V4 assistance request has no alarm to close', assistanceRequest.id);
  } catch (e) {
    consoleWarn('Closing the V4 assistance request failed', e);
  }
}

export const assistanceRequestSagas = [
  takeEvery(START_ASS_REQUEST, startAssistanceRequest),
  takeLatest(CLOSE_ASS_REQUEST, closeAssistanceRequest)
];
